module.exports = __webpack_public_path__ + "img/job_booking08.845cce66.png";